const getBaseURL = () => {
  switch (process.env.VUE_APP_ENVIRONMENT) {
    case 'dev':
      return 'https://dev-backend.buzzpowerai.com';
    case 'stage':
      return 'https://api-stage.buzzpowerai.com';
    case 'mig':
      return 'https://mig-backend.buzzpowerai.com/';
    case 'main':
      return 'https://api-prod.buzzpowerai.com';
    default:
      return 'http://localhost:4000';
  }
};

const mlBackend = () => {
  if (process.env.NODE_ENV === 'development') return 'https://devbuzzappengine.poweraiapi.com';

  let endpoint;
  switch (process.env.VUE_APP_ENVIRONMENT) {
    case 'dev':
      endpoint = 'https://devbuzzappengine.poweraiapi.com';
      break;
    case 'stage':
      endpoint = 'https://testbuzzappengine.poweraiapi.com';
      break;
    case 'main':
      endpoint = 'https://buzzappengine.poweraiapi.com';
      break;
    default:
      endpoint = 'https://devbuzzappengine.poweraiapi.com';
      break;
  }

  return endpoint;
};

export const baseURL = getBaseURL();

export const baseProcessUrl = mlBackend();
